<script setup lang="ts">
import { ref } from 'vue';

import VDialog from '@components/dialogs/VDialog/VDialog.vue';
import { useDevice } from '@modules/core/composables/device';

import type { IVSplitterProps, IVSplitterSlots } from './types';

defineProps<IVSplitterProps>();

defineSlots<IVSplitterSlots>();

const { isDesktop } = useDevice();

const dialogVisible = ref(false);
const dialogTitle = ref<string>();

function openItem(title = ''): void {
  dialogVisible.value = true;
  dialogTitle.value = title;
}

function handleDialogClose(): void {
  dialogVisible.value = false;
  dialogTitle.value = '';
}
</script>

<template>
  <PSplitter v-data-qa-auto-id="'VSplitter'"
    v-if="isDesktop"
    :pt="splitterRootPt"
  >
    <PSplitterPanel
      v-bind="leftPrimeVueProps"
      :pt="leftPrimeVuePt"
    >
      <slot
        name="left"
        :open-item="openItem"
      />
    </PSplitterPanel>
    <PSplitterPanel
      v-bind="rightPrimeVueProps"
      :pt="rightPrimeVuePt"
    >
      <slot name="right" />
    </PSplitterPanel>
  </PSplitter>
  <template v-else>
    <div>
      <div class="border">
        <slot
          name="left"
          :open-item="openItem"
        />
      </div>
      <VDialog
        :visible="dialogVisible"
        :title="dialogTitle"
        @hide="handleDialogClose"
      >
        <slot
          name="right"
        />
      </VDialog>
    </div>
  </template>
</template>
